import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Modal } from "react-bootstrap";
import { FiSearch, FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import "../styles/searchbar.css";
import api from "../api.js";

const SearchModal = () => {
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState({ fields: [], subjects: [], reports: [] });
  const inputRef = useRef();
  const token = Cookies.get("access_token");

  const handleSearch = async (q) => {
    if (!q.trim()) {
      setResults({ fields: [], subjects: [], reports: [] });
      return;
    }

    try {
      const res = await api.get(`/search/?q=${q}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setResults(res.data);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      handleSearch(query);
    }, 400);
    return () => clearTimeout(delay);
  }, [query]);

  useEffect(() => {
    if (show && inputRef.current) inputRef.current.focus();

    const handleEsc = (e) => {
      if (e.key === "Escape") setShow(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [show]);

  return (
    <>
      <button
        onClick={() => setShow(true)}
        className="search-btn"
      >
        <FiSearch size={18} />
      </button>

      <Modal show={show} onHide={() => setShow(false)} centered size="lg" dir="rtl">
        <Modal.Body className="p-4">
          <button
            onClick={() => setShow(false)}
            className="btn-close position-absolute top-0 end-0 m-3"
          >
            <FiX />
          </button>

          <input
            ref={inputRef}
            type="text"
            placeholder="جستجو..."
            className="form-control mb-4 text-end"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />

          {(results.fields.length || results.subjects.length || results.reports.length) ? (
            <div className="text-end" style={{ maxHeight: "50vh", overflowY: "auto" }}>
              {results.fields.length > 0 && (
                <>
                  <h6 className="text-primary fw-bold">فیلدها</h6>
                  <ul className="list-unstyled mb-3">
                    {results.fields.map((f) => (
                      <li key={`field-${f.id}`}>
                        <Link to={`/field/${f.id}`} onClick={() => setShow(false)} className="text-primary text-decoration-none d-block py-1">
                          {f.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              {results.subjects.length > 0 && (
                <>
                  <h6 className="text-success fw-bold">موضوعات</h6>
                  <ul className="list-unstyled mb-3">
                    {results.subjects.map((s) => (
                      <li key={`subject-${s.id}`}>
                        <Link to={`/subject/${s.id}`} onClick={() => setShow(false)} className="text-success text-decoration-none d-block py-1">
                          {s.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              {results.reports.length > 0 && (
                <>
                  <h6 className="text-purple fw-bold">گزارش‌ها</h6>
                  <ul className="list-unstyled">
                    {results.reports.map((r) => (
                      <li key={`report-${r.id}`}>
                        <Link to={`/report/${r.id}`} onClick={() => setShow(false)} className="text-purple text-decoration-none d-block py-1">
                          {r.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          ) : query.trim() ? (
            <div className="text-muted text-center mt-3">نتیجه‌ای یافت نشد.</div>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SearchModal;
